<template>
    <div class="how-block">
        <span class="how-block__heading">{{ heading }}</span>

        <div class="how-block__box">
            <div class="how-block__box-inner">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'HowBlock',
        props: {
            heading: String,
        }
    }
</script>